import React, { useState } from "react";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import {
	change,
	logout,
	profileimg,
	user,
} from "../Constant/Index";

const PhysicianProfileSidebar = () => {
	// Initialize with a default image or placeholder
	const [profileImage, setProfileImage] = useState(profileimg);

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = (e) => {
				setProfileImage(e.target.result);
			};
			reader.readAsDataURL(file);
		}
	};
	return (
		<>
			<div className="sidebar physician">
				<div className="profile-upload d-flex align-items-center justify-content-between p-3 border radius-20 mb-2">
					<div className="main-class d-flex align-items-center gap-2">
						<div className="upload-img-wrapper position-relative">
							<img
								id="profile-img"
								src={profileImage}
								className="img-fluid"
								alt="Profile"
							/>
							<div className="position-absolute bottom-0 right-0">
								<label htmlFor="file-upload" className="plus-icon-profile">
									<i className="fa-solid fa-plus"></i>
								</label>
								<input
									type="file"
									id="file-upload"
									accept="image/*"
									style={{ display: "none" }}
									onChange={handleImageChange}
								/>
							</div>
							<input
								type="file"
								id="file-input"
								style={{ display: "none" }}
								accept="image/*"
								onChange={handleImageChange}
							/>
						</div>
						<div className="profile-name">
							<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
								Dr. David Patel
							</h5>
							<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
								davidpatel@gmail.com
							</h6>
						</div>
					</div>
				</div>
				<div className="general-nav p-3 border radius-20 mb-2">
					<h5 className="main-heading level-6 main-heading-font dark-color">
						General
					</h5>
					<ul>
						<li className="">
							<NavLink
								to="/physician-personal-info"
								activeClassName="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={user} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											Edit Profile
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											Change profile picture, contact
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
						<li className="mt-4">
							<NavLink
								to="/physician-password"
								activeClassName="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={change} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											Change Password
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											Update and strengthen account security
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
						<li className="mt-4">
							<NavLink
								to="/physician-myconsultations"
								activeClassName="active"
								className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
							>
								<div className="main-class-list d-flex align-items-center gap-2">
									<img src={change} className="img-fluid" alt="Profile" />
									<div className="profile-name">
										<h5 className="main-heading level-7 mb-0 main-heading-font dark-color">
											My Consultations
										</h5>
										<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
											View Upcoming and Past Consultations
										</h6>
									</div>
								</div>
								<div className="edit-btn">
									<div className="nav-anchor">
										<i className="fa-solid fa-arrow-right"></i>
									</div>
								</div>
							</NavLink>
						</li>
					</ul>
				</div>
				<div className="login  p-3 border radius-20 mb-2">
					<Link
						to="/privacy-policy"
						className="nav-sidebar d-flex align-items-center justify-content-between text-decoration-none"
					>
						<div className="main-class-list d-flex align-items-center gap-2">
							<img src={logout} className="img-fluid" alt="Profile" />
							<div className="profile-name">
								<h5 className="main-heading level-7 mb-0 main-heading-font extra-color-11">
									Logout
								</h5>
								<h6 className="level-9 mb-0 primary-medium-font extra-color-12">
									Securely logout of account
								</h6>
							</div>
						</div>
						<div className="edit-btn">
							<div className="nav-anchor">
								<i className="fa-solid fa-arrow-right"></i>
							</div>
						</div>
					</Link>
				</div>
			</div>
		</>
	);
};

export default PhysicianProfileSidebar;
